import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import CarIcon from "../../icons/carIcon";
import { MENU_SLUG } from "../../constants/constants";
import RightArrowIcon from "../../icons/rightArrowIcon";
import CarBlack from "../../assets/images/carblack.png";
import CarWhite from "../../assets/images/carwhite.png";
import styles from "./style.module.css";

const CarChangeDropdown = ({ onCarChange, defaultCar, cars, disabled }) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleCarChange = async (car) => {
    onCarChange(car);
  };

  const handleDropdownClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.car_change_dropdown} ref={dropdownRef}>
      <button
        type="button"
        className={`${styles.ccr_btn} ${isOpen ? styles.ccr_btn_open : ""}`}
        onClick={handleDropdownClick}
        disabled={disabled}
      >
        {isOpen ? (
          <img src={CarWhite} alt="car" className={styles.ccrb_icon} />
        ) : (
          <img src={CarBlack} alt="car" className={styles.ccrb_icon} />
        )}
      </button>
      {isOpen && (
        <div className={styles.ccr_dropdown_list}>
          {cars.map((car, index) => (
            <button
              className={`${styles.ccrd_item} ${
                defaultCar?._id === car._id ? styles.ccrd_item_selected : ""
              }`}
              type="button"
              key={index}
              onClick={() => {
                handleCarChange(car);
                handleDropdownClick();
              }}
            >
              {car.name}
            </button>
          ))}
          <Link className={styles.ccrd_mc_btn} to={`/${MENU_SLUG.my_cars}`}>
            <CarIcon className={styles.ccrd_mc_icon} />
            <span className={styles.ccrd_mc_btn_text}>Manage Cars</span>
            <RightArrowIcon className={styles.ccrd_mc_arrow_icon} />
          </Link>
        </div>
      )}
    </div>
  );
};

export default CarChangeDropdown;
